import { render, staticRenderFns } from "./appWrite.vue?vue&type=template&id=32a7e871"
import script from "./appWrite.vue?vue&type=script&lang=js"
export * from "./appWrite.vue?vue&type=script&lang=js"
import style0 from "./appWrite.vue?vue&type=style&index=0&id=32a7e871&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports